import moment from 'moment';

const mapEventSchedulesFromApi = (
  resp: ApiListResponse<ApiEventScheduleItem>
): RemoteList<ScheduledEventItem> => {
  return {
    items: resp.items
      .filter((apiItem) => !!apiItem.event_id)
      .map((apiItem) => ({
        date: moment.unix(apiItem.date).toDate(),
        eventId: apiItem.event_id,
      })),
  };
};

export default mapEventSchedulesFromApi;
